import React, { useState } from 'react';
import './ContactForm.css';
import { supabase } from '../Supabase';
import StyledText from './TitlesSections';

const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    await supabase.from('Messages').insert({
      Sender_Name: name,
      Clients_emails: email,
      Message_Content: msg,
    });
  }

  return (
    <>
      <StyledText
        firstPart="Lets"
        secondPart="Connect"
        firstColor="#efa94b"
        secondColor="#FBECCA"
      />

      <form className="contact-form" onSubmit={handleSubmit} noValidate>
        <div className="contact-form__field">
          <label htmlFor="contact-name" className="contact-form__label">
            Name
          </label>
          <input
            id="contact-name"
            type="text"
            name="name"
            className="contact-form__input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="name"
            required
          />
        </div>

        <div className="contact-form__field">
          <label htmlFor="contact-email" className="contact-form__label">
            Email
          </label>
          <input
            id="contact-email"
            type="email"
            name="email"
            className="contact-form__input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </div>

        <div className="contact-form__field contact-form__field--message">
          <label htmlFor="contact-message" className="contact-form__label">
            Message
          </label>
          <textarea
            id="contact-message"
            name="message"
            className="contact-form__textarea"
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            rows={5}
            required
          />
        </div>

        <button type="submit" className="contact-form__submit">
          Send
        </button>
      </form>
    </>
  );
};

export default ContactForm;
